export default __webpack_public_path__ + "static/media/1330.c235f5d2.png";